import type { ShortCode } from '@highereducation/wordpress';
import { EmailBannerClient } from './EmailBannerClient';

/**
 * EmailBannerShortcode — `[hen-ui-email-banner]`
 *
 * Self-closing in-article email subscription banner. Renders the HEN
 * EmailBanner composite with Iterable subscription via hen-site BFF.
 * Interaction/view analytics are delegated via @highereducation/eventing
 * (hen.input, hen.button, hen.link, hen.emailBanner).
 */
export const EmailBannerShortcode: ShortCode<Record<string, never>> = {
  component: EmailBannerClient,
};

export { EmailBannerClient } from './EmailBannerClient';
